
<template>
    <transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
						<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
							<div class="modal-container" @click.stop>
				
								<div class="modal-header row" style="justify-content: flex-end;">
								<!-- <div class="col-6">
									<button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
								</div> -->
								<div class="col">
									<button type="button" class="close" @click="$emit('closeModal')">
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
								</div>
				
								<div class="modal-body">
									<h4 class="text-center">Print Tanda Terima Salvage Parts</h4>

									<div class="row mb-3">
										<div class="col-12 text-center">
											<button class="btn btn-info mr-3" style="width: 75px;" @click="printPage">Print</button>
											<button class="btn btn-primary" style="width: 75px;" @click="$emit('closeModal')">Kembali</button>
										</div>
									</div>
									<div class="innerBox"  id="printMe" >
								
										<h2>Tanda Terima Salvage Parts</h2>

										<div class="outerBox" style="margin: 20px 0">
											<div class="innerBox">
												<div class="row">
													<div class="col-6">
														<h4>Nomor Work Order</h4>
														<p>{{form_code}}</p>
													</div>
													<div class="col-6">
														<h4>Insurance Company</h4>
														<p>{{insurance_company}}</p>
													</div>
												</div>
											</div>
										</div>

										<vue-universal-table
											:disable_limit_per_page = "true"
											:pagination="false"
											:api_url="table.api_url"
											:update="table.update"
											:disable_sort="true"
											:indexing="true"
											:fields="table.fields"
										></vue-universal-table>

										<div class="mt-5 row pl-3 pr-3 text-center">
											<div class="offset-1 col-3" >
												<p style="margin-bottom:120px">Yang Menyerahkan,</p>
												<div style="border-bottom:1px solid black" class="w-100"></div>

											</div>
											<div class="offset-4 col-3">
												<p style="margin-bottom:120px">Yang Menerima,</p>
												<div style="border-bottom:1px solid black" class="w-100"></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>

export default {
	data () {
		return {
			
			editObj : null,
			modal : {
				edit : false,
				print : false
			},
			estimationData : null,
			form_code : this.$route.params.form_code,
			insurance_company : this.$route.params.insurance_company,
			table : {
				api_url : '/api/v1/salvage-part/' + this.$route.params.form_code,
				update : 0,
				buttons : [{
                    title : 'Edit',
					condition : 'data.id',
                    class : 'btn-outline-primary fas fa-edit'
				}, {
                    title : 'Delete',
					variable : 'id',
					condition : 'data.id',
                    class : 'btn-outline-danger fas fa-times'
				}],
				fields : [{
					title : 'Sparepart Name',
					variable : 'sparepart_name'
				}, {
					title : 'Amount',
					variable : 'amount',
					number_formatting : true
				}, {
					title : 'Salvaged',
					variable : 'Salvaged',
					'style_condition' : {
						'Y' : 'color : #2E8B57;font-weight:bold',
						'N' : 'color : red;font-weight:bold'
					}
				}, {
					title : 'Salvage Date',
					variable : 'salvage_date'
				}]
			}
		}
	},
	mounted () {
		this.getWoEstimation()
	},
	methods : {
		printPage(){
			this.$htmlToPaper('printMe');
			this.$emit('closeModal')
		},
		getWoEstimation() {
			this.$http.get('/api/v1/workorder-estimation/' + this.form_code)
			.then((resp)=> {
				this.estimationData = resp.data.data
				console.log(this.estimationData)
			})
			.catch((err) => {
				console.log(err)
			})
		},
		editSalvagePart(obj){
            this.editObj = JSON.parse(obj);
            this.modal.edit = true;
        },
        deleteSalvagePart(id){
            this.$swal.fire({
                title: 'Apakah anda yakin?',
                text: "Salvage part akan dihapus!",
                type: 'warning',
                showCancelButton: true
                }).then((result) => {
                if (result.value) {
                    this.$http.delete(`/api/v1/salvage-part/${id}`)
                    .then((resp)=>{
                        this.vue_universal_table.update++;
                        this.$swal.fire(
                            'Berhasil!',
                            'Salvage part telah berhasi dihapus',
                            'success'
                        )
                    })
                    .catch((err)=>{console.log(err)})
                }
            })
        }
	}
	
}
</script>

<style scoped>
	p {
		font-size: 15px;
	}
</style>